import axios, {AxiosInstance, AxiosRequestConfig} from 'axios';
import EnvConstants, {isDev} from '@/constants/environment';
import {isCbDomain} from '@/utils/utility-functions';

const API: Array<API> = [
  {
    name: 'payment_intent',
    actions: [
      {
        name: 'confirm',
        method: 'post',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        // endpoint: "/api/internal/payment_intent/confirm",
        // TODO REMOVE THIS
        endpointFn: ({paymentIntentId}) => `/api/v1/checkout_intents/${paymentIntentId}/confirm`,
      },
      {
        name: 'retrieve',
        method: 'get',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
        },
        endpoint: '/api/internal/payment_intents/retrieve',
      },
    ],
  },
];

type API = {
  name: string;
  actions: Action[];
};

type Action = {
  name: string;
  method: 'get' | 'post';
  endpoint?: string;
  endpointFn?: Function;
  headers?: any;
};

export interface ApiClientInstance {
  [key: string]: any;
}

export class ApiClient implements ApiClientInstance {
  private axios: AxiosInstance;

  private site: string;
  private authToken: string;
  private customDomain: string;
  private hostName: string;

  constructor(site: string, authToken: string, options: any = {}) {
    this.site = site;
    this.authToken = authToken;
    this.hostName = options.hostName;
    this.customDomain = options.customDomain;

    this.axios = axios.create({
      baseURL: this.getDomain(),
      transformRequest: (data, headers) => {
        return JSON.stringify(data);
      },
    });

    var that = this;
    API.forEach((endpoint) => {
      endpoint.actions.forEach((action) => {
        that[endpoint.name] = {};
        that[endpoint.name][action.name] = function (params, headers): Promise<any> {
          return new Promise((resolve, reject) => {
            that.axios
              .request(that.requestConfig(action, params, headers))
              .then((response) => {
                resolve(response.data);
              })
              .catch((error) => {
                reject(error);
              });
          });
        };
      });
    });
  }

  getDomain(): string {
    if (isDev()) {
      if (this.customDomain) {
        const customDomains = this.customDomain.split(',');
        try {
          const customDomain = customDomains[0];
          const url = new URL(customDomain);
          return url.origin;
        } catch (e) {
          console.error(new Error(`Invalid custom domain ${this.customDomain}`));
        }
      }
    }
    return isCbDomain(this.hostName) ? this.hostName : EnvConstants.APP_DOMAIN.replace('${site}', this.site);
  }

  private requestConfig(action, params, headers = {}): AxiosRequestConfig {
    var config = {
      url: action.endpointFn ? action.endpointFn(params) : action.endpoint,
      method: action.method,
    };
    if (this.authToken) config['Authorization'] = `Bearer ${this.authToken}`;
    if (action.method == 'post') {
      config['headers'] = Object.assign({'Content-Type': 'application/json'}, headers);
      config['data'] = params;
    } else {
      config['headers'] = headers;
      config['params'] = params;
    }
    return config;
  }
}
